var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"text-xs-center"},[_c('div',{staticStyle:{"padding":"20px"}},[_c('h4',{domProps:{"textContent":_vm._s(_vm.text)}})]),_c('v-progress-circular',{attrs:{"size":50,"indeterminate":"","color":"primary"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }